import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Modal as MUIModal,
  Typography,
} from "@mui/material";
import { ButtonLoader } from "../inputs.styled";
import CloseIcon from "@mui/icons-material/Close";
import { Close } from "@mui/icons-material";

const Modal = ({
  open,
  onClose,
  disableEscapeKeyDown = false,
  width,
  borderRadius,
  message,
  secondaryButtonText,
  primaryButtonText,
  handleSubmit,
  title,
  isLoading,
  handleSecondaryButton,
  padding,
  height,
  children,
  backgroundOverlay = true,
  left = "50%",
  top = "50%",
  disableScrollLock = false,
  blueCloseIcon = false,
  customBorder,
  boxShadow = 0,
  position = "fixed",
  gap = "10px",
  closeIcon = true,
  isCheckbox = false,
  onCheckboxChange = () => {},
}) => {
  const ModalStyles = {
    position: position,
    top,
    left,
    transform: "translate(-50%, -50%)",
    width,
    minHeight: height,
    maxHeight: "fit-content",
    borderRadius,
    border: customBorder ? customBorder : "1px solid #EFF4FF",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFF",
    padding,
    gap,
    boxSizing: "border-box",
    outline: "none",
    boxShadow: boxShadow,

    "&:focus-visible": {
      outline: "none",
    },
  };

  const [checked, setChecked] = useState(false);

  const handleApplyBboxCheckbox = (event) => {
    setChecked(event.target.checked);
    onCheckboxChange(event);
  };

  return (
    <MUIModal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: {
          backgroundColor: backgroundOverlay ? "#F6F7F9" : "transparent",
          opacity: backgroundOverlay ? 0.8 : 0,
        },
      }}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableScrollLock={disableScrollLock}
    >
      <Box sx={ModalStyles}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {title && (
            <Typography
              sx={{
                width: "100%",
                textAlign: "center",
                color: "#123051",
                fontSize: "14px",
                fontFamily: "DM Sans",
                fontWeight: "500",
                wordWrap: "break-word",
              }}
            >
              {title}
            </Typography>
          )}
          {closeIcon &&
            (blueCloseIcon ? (
              <Box
                onClick={onClose}
                style={{
                  // backgroundColor: "#123051",
                  borderRadius: "12.5px",
                  cursor: "pointer",
                  position: "absolute",
                  right: 15,
                  // top: "-75px",
                  height: "10px",
                  width: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 60,
                }}
              >
                <Close
                  style={{
                    color: "#123051",
                  }}
                />
              </Box>
            ) : (
              <IconButton onClick={onClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            ))}
        </div>

        {children && children}

        {message && (
          <Typography
            sx={{
              width: "100%",
              textAlign: "center",
              color: "#000",
              fontSize: "12px",
              fontFamily: "DM Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            {message}
          </Typography>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "6px",
            marginTop: "10px",
          }}
        >
          {secondaryButtonText && (
            <Button
              variant="outlined"
              sx={{
                textAlign: "center !important",
                color: "#123051 !important",
                fontSize: "8px !important",
                fontFamily: "DM Sans !important",
                fontWeight: "400 !important",
                wordWrap: "break-word !important",
                padding: "6px 20px !important",
                background: "#e1e1e1 !important",
                borderRadius: "20px !important",
                overflow: "hidden !important",
                border: "1px solid #123051 !important",
              }}
              onClick={handleSecondaryButton}
            >
              {secondaryButtonText}
            </Button>
          )}
          {primaryButtonText && (
            <Button
              variant="contained"
              sx={{
                textAlign: "center !important",
                color: "#FFFFFF !important",
                fontSize: "8px !important",
                fontFamily: "DM Sans !important",
                fontWeight: "400 !important",
                wordWrap: "break-word !important",
                padding: "6px 20px !important",
                background: "#123051 !important",
                borderRadius: "20px !important",
                overflow: "hidden !important",

                "&:hover": {
                  background: "#c63213 !important",
                },
              }}
              onClick={handleSubmit}
            >
              {isLoading && <ButtonLoader />} {primaryButtonText}
            </Button>
          )}
        </Box>

        {isCheckbox && (
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <Checkbox
              checked={checked}
              onChange={handleApplyBboxCheckbox}
              sx={{ padding: 0 }}
            />
            <Typography
              variant="h6"
              style={{
                fontSize: "10px",
                fontFamily: "DM Sans",
                textAlign: "center",
                whiteSpace: "nowrap",
              }}
            >
              Never Show Again
            </Typography>
          </Box>
        )}
      </Box>
    </MUIModal>
  );
};

export default Modal;
